import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { IconSvgComponent, PageScrollDirective, SkeletonGridComponent } from '@roomex/rx-components';
import { FeatureFlagFacade } from '@rx-applications/shared/clientsite/feature-flags';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';
import { AuthApiFacade } from '@rx-applications/shared/auth/api';
import { ROUTES_PATH } from '@rx-applications/clientsite/admin/utils';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'rx-applications-navigation-menu',
  standalone: true,
  templateUrl: './navigation-menu.component.html',
  styleUrl: './navigation-menu.component.scss',
  imports: [CommonModule, RouterModule, IconSvgComponent, TranslocoDirective, PageScrollDirective, SkeletonGridComponent],
  providers: [translationProvider],
})
export class NavigationMenuComponent{
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  readonly ROUTES_PATH = ROUTES_PATH;
  readonly configFacade = inject(ConfigFacade);
  readonly featureFlagFacade = inject(FeatureFlagFacade);
  readonly authApiFacade = inject(AuthApiFacade);
  readonly testIdPrefix = 'navigation-menu';

  readonly selfUserManagementEnabled = toSignal(this.featureFlagFacade.selfUserManagementEnabled$);
  readonly selfCustomFieldsEnabled = toSignal(this.featureFlagFacade.enableSelfCustomFieldEnabled$);
  readonly allowCompanyPaymentPage = toSignal(this.configFacade.allowCompanyPaymentPage$);
}

